<template>
	<div class="omapi-card__flex omapi-dash__create">
		<templates-type-card
			class="omapi-dash__create-card"
			size="half"
			v-for="(typeLabel, type) in templateTypes"
			:key="'template-type-' + type"
			:type="type"
			:typeLabel="typeLabel"
		>
			<core-button :linkStyle="true" :arrow="true">Create New</core-button>
		</templates-type-card>
	</div>
</template>

<script>
export default {
	computed : {
		templateTypes () {
			return this.$store.getters['templates/typeNames']
		},
	},
}
</script>
